<ngb-datepicker
  #dp
  class="custom-datepicker px-2 pt-1 pb-3 w-100 border-0"
  navigation="none"
  [formControl]="dateControl"
  [minDate]="minDate | toNGBDate"
  [maxDate]="maxDate | toNGBDate"
  [weekdays]="showWeekdays"
  [startDate]="startDate | toNGBDate"
>
  <ng-template ngbDatepickerContent>
    <!-- only one month supported -->
    <div *ngIf="dp.state.firstDate as firstMonth">
      <atx-date-picker-navigation
        (previous)="navigate(-1)"
        (next)="navigate(1)"
        (titleClick)="toggleCalendar()"
      >
        {{
          firstMonth.year + '-' + firstMonth.month + '-' + 1 | date: 'MMM yyyy'
        }}
      </atx-date-picker-navigation>
      <atx-month-picker
        [class.d-none]="!hideCalendar"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [month]="firstMonth.month"
        [year]="firstMonth.year"
        (monthSelect)="monthSelected($event)"
      ></atx-month-picker>

      <div
        [ngClass]="{
          'd-flex': !hideCalendar,
          'd-none': hideCalendar
        }"
      >
        <atx-week-number
          *ngIf="showWeekNumbers"
          [firstEmpty]="showWeekdays"
          [weeksPresetData]="weeksPresetData"
          [startingDay]="{
            year: firstMonth.year,
            month: firstMonth.month,
            day: firstMonth.day
          }"
        ></atx-week-number>
        <ngb-datepicker-month [month]="firstMonth"></ngb-datepicker-month>
      </div>

      <div
        *ngIf="showWeekNumbers && !isObjectEmpty(weeksPresetData)"
        class="text-center"
        i18n="DatePicker@@unlimitedItemsAreOfferedExplanation"
      >
        <atx-asterisk></atx-asterisk>
        Unlimited Quantity Available
      </div>
    </div>
  </ng-template>
</ngb-datepicker>
